//PATRICK
//QUESTO GESTISCE IL PACCHETTO PER IL REGALO TRAMITE INPUT A CARRELLO
class CustomGiftInputManager extends HTMLElement {

    constructor(){
        super();
    }

    connectedCallback(){
        this.input = document.querySelector('#custom-gift-box-input');
        this.input.addEventListener("change", () => {
            if(this.input.checked){
                console.log('dubs');
                var formData = {
                    'items': [
                        {
                            'id': parseInt(this.dataset.product),
                            'quantity': 1
                        }
                    ]
                };
                var addUrl = window.Shopify.routes.root + 'cart/add.js'
                fetch(addUrl, {
                    body: JSON.stringify(formData),
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                      },
                }).then(response => {
                    document.querySelector('cart-drawer-items').onCartUpdate();
                })            
            }
            else{
                var formData = {
                    'id': `${parseInt(this.dataset.product)}`,
                    'quantity': 0
                };
                var updateUrl = window.Shopify.routes.root + 'cart/change.js'
                fetch(updateUrl, {
                    body: JSON.stringify(formData),
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                      },
                }).then(response => {
                    document.querySelector('cart-drawer-items').onCartUpdate();
                })            
            }
        });
    }
}
if(!window.customElements.get("custom-gift-checkbox-manager")){
    window.customElements.define("custom-gift-checkbox-manager", CustomGiftInputManager);
}
//QUESTO GESTISCE IL PRODOTTO OMAGGIO AL RAGGIUNGIMENTO DELLA SOGLIA DI PREZZO
class PromoItemManager extends HTMLElement {
    constructor(){
        super()
    }

    connectedCallback(){
        this.setup();
        setTimeout(this.manageGift, 500);
    }
    setup = () => {
        this.thresholdReached = this.dataset.thresholdReached === 'true';
        this.promoProductId = this.dataset.id;
        this.isIncluded = this.dataset.included === 'true';
        this.cartUpdatedEvent = new CustomEvent('cartUpdated', {
        detail: {
          message: 'Cart was updated',
        }
      });
        console.log('REACHED: ', this.thresholdReached);
        console.log('ID: ', this.promoProductId);
        console.log('INCLUDED: ', this.isIncluded);
    }

    manageGift = () => {
        if( (this.isIncluded && this.thresholdReached) || (!this.isIncluded && !this.thresholdReached) ){
            console.log('My job here is done...');
            return;
        }
        const updates = {}
        if(this.thresholdReached){
            updates[parseInt(this.promoProductId)] = 1;
        }
        else{
            updates[parseInt(this.promoProductId)] = 0;
            
        }
        var updateUrl = window.Shopify.routes.root + 'cart/update.js'
        fetch(updateUrl, {
            body: JSON.stringify({ updates }),
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
              },
        }).then(response => {
            return response.text();
        }).then(text => {
            //document.querySelector('cart-drawer-items').onCartUpdate();
            const parsedState = JSON.parse(text);
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: parsedState, variantId: this.promoProductId });
        })
        
    }
    
}
if(!window.customElements.get("promo-item-manager")){
    window.customElements.define("promo-item-manager", PromoItemManager);
}